import React from "react";
import { useTranslation, Trans } from "react-i18next";
import Card from "../../components/card/card";
import HomeBanner from "./home-banner/home-banner";
import Subsection from "../../components/subsection/subsection";
import SubsectionSecondary from "../../components/subsection-secondary/subsection-secondary";
import SwiperComponent from "../../../../shared/components/swiper-template/swiper-template";
import SwiperComponentSecondary from "../../../../shared/components/swiper-template-secondary/swiper-template-secondary";
import CardTestimony from "./card-testimony/card-testimony";
import SubscribeSection from "./subscribe-section/subscribe-section";
import testimony1 from "../../assets/images/testimony1.jpeg";
import testimony2 from "../../assets/images/testimony2.jpg";
import testimony3 from "../../assets/images/testimony3.jpeg";
import imageSwiperSecondary1 from "../../assets/swipersecondary/booste-reseau-2026.jpeg";
import imageSwiperSecondary2 from "../../assets/swipersecondary/affine-projet-pro.jpg";
import imageSwiperSecondary3 from "../../assets/swipersecondary/organise-events-2026.jpg";
import "./home.scss";

// youtube = VIDEO_ID uniquement (ex: "syaXZDpxzs8")
const videoUrl = "Mm8jqe7c5s0";

const CardList = [
    {
        title: "home.card.network.title",
        text: "home.card.network.content",
        id: "network",
    },
    {
        title: "home.card.job.title",
        text: "home.card.job.content",
        id: "job",
    },
    {
        title: "home.card.school.title",
        text: "home.card.school.content",
        id: "school",
    },
];

const SubsectionSecondaryList = [
    {
        title: "home.subsectionSecondary.content1.title",
        text: "home.subsectionSecondary.content1.text",
        imageSrc: imageSwiperSecondary1,
        id: "content1",
    },
    {
        title: "home.subsectionSecondary.content2.title",
        text: "home.subsectionSecondary.content2.text",
        imageSrc: imageSwiperSecondary2,
        id: "content2",
    },
    {
        title: "home.subsectionSecondary.content3.title",
        text: "home.subsectionSecondary.content3.text",
        imageSrc: imageSwiperSecondary3,
        id: "content3",
    },
];

const Home = () => {
    const { t } = useTranslation();
    const linkedinCapgemini = "https://www.linkedin.com/feed/hashtag/?keywords=capgeministudentconnection";
    const linkedinPost1 = "https://www.linkedin.com/feed/update/urn:li:activity:7384536115913056256/"
    const linkedinPost2 = "https://www.linkedin.com/feed/update/urn:li:activity:7396144731849801728/"
    const linkedinPost3 = "https://www.linkedin.com/feed/update/urn:li:activity:7435247788621230080/"

    return (
        <div className="home">
            <HomeBanner />

            <SubscribeSection />

            <SwiperComponent className="swiper-cards">
                {CardList.map((card) => (
                    <Card
                        className={`home__card-list__item home__card-list__item--${card.id}`}
                        title={card.title}
                        text={card.text}
                        key={card.id}
                    />
                ))}
            </SwiperComponent>
            <div className="home__subsection">
                <Subsection mediaType="video" mediaUrl={videoUrl} textTitle={<Trans i18nKey="home.program.text" />} />
            </div>
            
            <div className="home-swiper-component-secondary">
                <SwiperComponentSecondary className="swiper-secondary">
                    {SubsectionSecondaryList.map((subsectionSecondary) => (
                        <SubsectionSecondary
                            key={subsectionSecondary.id}
                            title={subsectionSecondary.title}
                            text={subsectionSecondary.text}
                            buttonText={subsectionSecondary.buttonText}
                            buttonLink={subsectionSecondary.buttonLink}
                            imageSrc={subsectionSecondary.imageSrc}
                        />
                    ))}
                </SwiperComponentSecondary>
            </div>

            <div className="home__testimony">
                <a className="home__testimony__title-link" href={linkedinCapgemini}>
                    <h2 className="home__testimony__title">{t("home.linkedInPost.title")}</h2>
                </a>
                <SwiperComponent className="swiper-card-testimony home__testimony__wrapper">
                    <a className="home__testimony__link home__linkedInPost__link" href={linkedinPost2} target="_blank" rel="noreferrer">
                        <CardTestimony
                            name="home.linkedInPost.content.1.name"
                            job="home.linkedInPost.content.1.job"
                            text="home.linkedInPost.content.1.text"
                            profile={testimony2}
                        />
                    </a>
                    <a className="home__testimony__link home__linkedInPost__link" href={linkedinPost1} target="_blank" rel="noreferrer">
                        <CardTestimony
                            name="home.linkedInPost.content.0.name"
                            job="home.linkedInPost.content.0.job"
                            text="home.linkedInPost.content.0.text"
                            profile={testimony1}
                        />
                    </a>
                    <a className="home__testimony__link home__linkedInPost__link" href={linkedinPost3} target="_blank" rel="noreferrer">
                        <CardTestimony
                            name="home.linkedInPost.content.2.name"
                            job="home.linkedInPost.content.2.job"
                            text="home.linkedInPost.content.2.text"
                            profile={testimony3}
                        />
                    </a>
                </SwiperComponent>
            </div>
        </div>
    );
};

export default Home;
